"use client";
import { useEffect, useRef } from "react";
const isApple = () => typeof navigator !== "undefined" &&
    /Mac|iPod|iPhone|iPad/.test(navigator.platform);
function isFormField(target) {
    if (!(target instanceof HTMLElement))
        return false;
    if (target.isContentEditable)
        return true;
    return ["INPUT", "TEXTAREA", "SELECT"].includes(target.tagName);
}
function matches(event, combo) {
    const parts = combo.toLowerCase().split("+");
    const key = parts[parts.length - 1] ?? "";
    const needsMod = parts.includes("mod");
    const needsShift = parts.includes("shift");
    const needsAlt = parts.includes("alt");
    const modActive = isApple() ? event.metaKey : event.ctrlKey;
    if (needsMod !== modActive)
        return false;
    if (needsShift !== event.shiftKey)
        return false;
    if (needsAlt !== event.altKey)
        return false;
    return event.key.toLowerCase() === key;
}
/**
 * Global keyboard bindings. Registered on `document` so a shortcut works from
 * anywhere in the app, which is the whole point of a keyboard-first console.
 */
export function useHotkeys(bindings) {
    const ref = useRef(bindings);
    ref.current = bindings;
    useEffect(() => {
        const onKeyDown = (event) => {
            for (const binding of ref.current) {
                if (!matches(event, binding.combo))
                    continue;
                if (!binding.enableInFormFields && isFormField(event.target))
                    continue;
                if (binding.preventDefault !== false)
                    event.preventDefault();
                binding.handler(event);
                return;
            }
        };
        document.addEventListener("keydown", onKeyDown);
        return () => document.removeEventListener("keydown", onKeyDown);
    }, []);
}
/** Renders "⌘K" on Apple and "Ctrl K" elsewhere without a hydration mismatch. */
export function formatCombo(combo) {
    return combo
        .split("+")
        .map((part) => {
        if (part === "mod")
            return isApple() ? "⌘" : "Ctrl";
        if (part === "shift")
            return "⇧";
        if (part === "alt")
            return isApple() ? "⌥" : "Alt";
        if (part === "escape")
            return "Esc";
        return part.length === 1 ? part.toUpperCase() : part;
    })
        .join(isApple() ? "" : " ");
}
//# sourceMappingURL=use-hotkeys.js.map